import React from "react"

// s4n
import { injectIntl, Link } from "gatsby-plugin-intl"
import kebabCase from "lodash.kebabcase"
import classNames from 'classnames';
// import "./../../assets/sass/templates/node/_blog.scss"



const ComponentStateless = (props) => {
    const { 
        intl, 
        pageContext, linkTranslation, // static pager
    } = props
    const t = intl.formatMessage;

    // Paging context and differentiator (Shop category or Blog tag) context together
    let differentiatorUrlPart = ``;
    if (typeof pageContext.category !== `undefined`) {
        differentiatorUrlPart = pageContext.category ? `/${kebabCase(pageContext.category)}` : ``; // if we just use pagination or we are in category context
    } else if (typeof pageContext.tag !== `undefined`) {
        differentiatorUrlPart = pageContext.tag ? `/tag/${kebabCase(pageContext.tag)}` : ``; // if we just use pagination or we are in tag context
    }

    const generatePageLink = (index) => index === 1 ? `/${linkTranslation}${differentiatorUrlPart}` : `/${linkTranslation}${differentiatorUrlPart}/${index}`;
    // const first = `/${linkTranslation}${differentiatorUrlPart}`;
    // const last = pageContext.numPages <= 1 ? `/${linkTranslation}${differentiatorUrlPart}` : `/${linkTranslation}${differentiatorUrlPart}/${pageContext.numPages}`;

    // @see: pageContext.currentPage for 1st page is 1 not 0!!!
    const prev = generatePageLink(pageContext.currentPage - 1);
    const next = generatePageLink(pageContext.currentPage + 1);

    const PageItemClassPrev = classNames({
        'page-item _disabled clearfix d-none d-md-block': true,
        'disabled': pageContext.currentPage === 1,
    });

    const PageItemClassNext = classNames({
        'page-item _disabled clearfix d-none d-md-block': true,
        'disabled': pageContext.currentPage === pageContext.numPages,
    });

    return (
        <div className="container mb-3">
            <ul className="pagination pagination-circle pg-blue mb-0 static">
                {/* <li className="page-item _disabled clearfix d-none d-md-block">
                    <Link to={first} className="page-link">{ t({ id: "soft4net_pagination_first" }) }</Link>
                </li> */}

                <li className={PageItemClassPrev}>
                    <Link to={prev} className="page-link">{ t({ id: "soft4net_pagination_prev" }) }</Link>
                </li>
                {/* <li className="page-item disabled">
                    <a className="page-link" aria-label="Previous">
                        <span aria-hidden="true">«</span>
                        <span className="sr-only">Previous</span>
                    </a>
                </li> */}
                
                {Array.from({ length: pageContext.numPages }).map((item, i) => {
                    const index = i + 1

                    const PageItemClass = classNames({
                        'page-item': true,
                        'active': pageContext.currentPage === index,
                        // 'disabled': pageContext.currentPage === index,
                    });

                    return (
                    <li key={`pagination-page-link-${i}`} className={PageItemClass}>
                        {pageContext.currentPage === index ? (
                            <span className="page-link">{index}</span>
                        ) : (
                            <Link to={generatePageLink(index)} className="page-link">{index}</Link>
                        )}
                    </li>
                    )
                })}

                {/* <li className="page-item">
                    <a className="page-link" aria-label="Next">
                        <span aria-hidden="true">»</span>
                        <span className="sr-only">Next</span>
                    </a>
                </li> */}
                <li className={PageItemClassNext}>
                    <Link to={next} className="page-link">{ t({ id: "soft4net_pagination_next" }) }</Link>
                </li>

                {/* <li className="page-item clearfix d-none d-md-block">
                    <Link to={last} className="page-link">{ t({ id: "soft4net_pagination_last" }) }</Link>
                </li> */}
            </ul>
        </div>
    )
}

export default injectIntl(ComponentStateless)